import styled, { css } from 'styled-components'
import { flexItem } from '../../themes/Mixins'

export const Col = styled.div`
  ${props => flexItem(
    props.align || '',
    props.flexGrow || '',
    props.order || ''
  )};

  padding: ${props => props.padding || ''};
  ${props => css`${props.customStyle}`};
`

// col-12: 100%
export const Col12 = Col.extend`
  width: 100%;
`

// col-9: 75%
export const Col9 = Col.extend`
  width: 75%;
`

// col-8: 66.66%
export const Col8 = Col.extend`
  width: 66.66%;
`

// col-6: 50%
export const Col6 = Col.extend`
  width: 50%;
`

// col-4: 33.33%
export const Col4 = Col.extend`
  width: 33.33%;
`

// col-3: 25%
export const Col3 = Col.extend`
  width: 25%;
`




// WEBPACK FOOTER //
// ./src/components/common/Grid.js